import { FetchPermissionsRoutine, SetUserRoutine } from './redux-routines';
import * as API from './api';
import { ability } from '@oliasoft/authorization-ui';
import { saveLocalStoreData } from '../../services/local-storage.service';
import httpClient from '~utils/httpClient';

export const fetchPermissions = () => async dispatch => {
  dispatch(FetchPermissionsRoutine.request());
  try {
    const { data } = await API.fetchPermissions();
    dispatch(FetchPermissionsRoutine.success(data));
  } catch (e) {
    dispatch(FetchPermissionsRoutine.failure(e));
  }
};

/** @type {(token: string) => (dispatch: any) => Promise<any>} */
export const userLoginToken = (token) => async (dispatch) => {
  try {
    const { data } = await httpClient({
      method: 'post',
      url: 'api/tokenlogin',
      baseURL: '/',
      data: {token}
    });
    saveLocalStoreData('permissions', data.abilities, true);
    saveLocalStoreData('user', data.user, true);

    return ability.update(data.abilities);
  } catch (err) {
    dispatch(SetUserRoutine.failure(err));
  }
};
